import type {DocumentFSUpdate} from '@wix/anyide-cli-types'
import {deepClone} from '@wix/wix-immutable-proxy'

export class DocumentUpdateState {
    private EMPTY_STATE: DocumentFSUpdate = {pages: {}}
    private state: DocumentFSUpdate

    constructor() {
        this.state = this.EMPTY_STATE
    }

    getState(): DocumentFSUpdate {
        return deepClone(this.state)
    }

    append(documentUpdate: DocumentFSUpdate): DocumentFSUpdate {
        this.state = {
            ...this.state,
            ...documentUpdate,
            pages: {
                ...this.state.pages,
                ...documentUpdate.pages
            }
        }
        return this.getState()
    }

    clear() {
        this.state = this.EMPTY_STATE
    }
}
